// Import of the module
import { formatNumber } from "@/lib/utils";
import i18n from "@/i18n";
import { Link } from "@heroui/link";
import { ColumnDef } from "@tanstack/react-table";

// Type of the fields in the table
export type EnumTranslation = {
  id: number;
  class_name?: string | null;
  column_name?: string | null;
  enum_code?: number | null;
  pg_code?: string | null;
  enum_key?: string | null;
  fr_translation?: string | null;
  en_translation?: string | null;
};

// Definition of the columns
export const enum_translation_columns: ColumnDef<EnumTranslation>[] = [
  {
    accessorKey: "id",
    header: "Id",
  },
  {
    accessorKey: "class_name",
    header: "Class Name",
  },
  {
    accessorKey: "column_name",
    header: "Column Name",
  },
  {
    accessorKey: "enum_code",
    header: "Enum Code",
    cell: ({ row }) => {
      const value = row.getValue<number | null>("enum_code");
      return value != null ? formatNumber(value) : "";
    },
  },
  {
    accessorKey: "pg_code",
    header: "PG Code",
  },
  {
    accessorKey: "enum_key",
    header: "Enum Key",
  },
  {
    accessorKey: "fr_translation",
    header: "FR Translation",
  },
  {
    accessorKey: "en_translation",
    header: "EN Translation",
  },
  {
    id: "actions",
    header: () => <div className="text-right">Actions</div>,
    cell: ({ row }) => (
      <div className="flex justify-end">
        <Link
          href={`${window.location.pathname}/${row.getValue<number>("id")}`}
          className="text-xs"
          underline="hover"
        >
          {i18n.t("actions.edit")}
        </Link>
      </div>
    ),
  },
];
